module.exports = __webpack_public_path__ + "static/img/mkf.8108a2fe.png";